import { useMutation, useQueryClient } from "react-query";
import { useForm } from "react-hook-form";
import { api } from "utils/api";
import type { ReviewVote } from "../types";
import { reviewKeys } from "./queryKeys";

type ReviewVoteType = { reviewableId: string };

type BaseReviewVoteUpdates = ReviewVoteType & {
  reviewId: string;
};

type ReviewVoteFormFields = Pick<
  ReviewVote,
  "vote" | "moderatorFeedback" | "moderatorVote"
>;

type ReviewVoteUpdates = BaseReviewVoteUpdates & ReviewVoteFormFields;

// type UpdateReviewVoteResp = {
//   reaction: ReviewVote;
//   review: ProjectReview | ArtistReview;
// };

const updateReviewVote = async ({ vote, ...updates }: ReviewVoteUpdates) =>
  api.put("/reviews/react", {
    body: JSON.stringify({ ...updates, reaction: vote }),
  });

const useUpdateReviewVote = (updates: BaseReviewVoteUpdates) => {
  const queryClient = useQueryClient();

  const { mutate, ...mutation } = useMutation(
    (fields: ReviewVoteFormFields) =>
      updateReviewVote({ ...updates, ...fields }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          reviewKeys.infinite({
            artistId: updates.reviewableId,
          }),
        );

        queryClient.invalidateQueries(["reviews", "pending"]);
      },
    },
  );

  return { updateReviewVote: mutate, ...mutation };
};

const useModeratorFeedbackForm = () =>
  useForm<ReviewVoteFormFields>({
    defaultValues: {
      moderatorFeedback: "",
      vote: "downvote",
    },
  });

export { useUpdateReviewVote, useModeratorFeedbackForm };
